<template>
  <div class="rightFixedBox">
    <div class="center pr transBox">
      <transition name="slide-fade">
        <div
          v-show="btnShow[0].DesInfoShow"
          class="transInfo"
          :style="{top:btnTopDistance[0] - btnOffset+'px'}"
        >
          <router-link :to="{name:LinkTypeCode.Mine}" tag="a" target="_blank" class="cfff">个人中心</router-link>
        </div>
      </transition>
      <transition name="slide-fade">
        <div
          v-show="btnShow[1].DesInfoShow"
          class="transInfo"
          :style="{top:btnTopDistance[1] - btnOffset+'px'}"
        >
          <router-link :to="{name:LinkTypeCode.MyCoupon}" tag="a" target="_blank" class="cfff">我的优惠券
          </router-link>
        </div>
      </transition>
      <transition name="slide-fade">
        <div
          v-show="btnShow[2].DesInfoShow"
          class="transInfo"
          :style="{top:btnTopDistance[2] - btnOffset+'px'}"
        >
          <router-link :to="{name:LinkTypeCode.MyCollection}" tag="a" target="_blank" class="cfff">我的收藏
          </router-link>
        </div>
      </transition>
      <transition name="slide-fade">
        <div
          v-show="btnShow[3].DesInfoShow"
          class="transInfo"
          :style="{top:btnTopDistance[3] - btnOffset+'px'}"
        >
          <router-link :to="{name:LinkTypeCode.Msg}" tag="a" target="_blank" class="cfff">我的消息</router-link>
        </div>
      </transition>
      <transition name="slide-fade">
        <div
          v-show="btnShow[7].DesInfoShow"
          class="transInfo"
          :style="{top:btnTopDistance[7] - btnOffset+'px'}"
        >
          <!-- <router-link :to="{name:LinkTypeCode.Msg}" tag="a" target="_blank" class="cfff">在线客服</router-link> -->
          <div>在线客服</div>
        </div>
      </transition>
      <transition name="slide-fade">
        <div
          v-show="btnShow[4].DesInfoShow"
          class="transInfo"
          :style="{top:btnTopDistance[4] - btnOffset-2+'px'}"
        >顶部
        </div>
      </transition>
      <transition name="slide-fade">
        <div v-show="btnShow[5].DesInfoShow" class="transInfo qrcode" :style="{top:btnTopDistance[5] -50+'px'}">
          <van-icon :name="require('@/assets/download/qrcode.png')" size="120px" />
        </div>
      </transition>
      <transition name="slide-fade">
        <div
          v-show="btnShow[6].DesInfoShow"
          class="transInfo"
          :style="{top:btnTopDistance[6] - btnOffset+'px'}"
        >
          <router-link :to="{name:LinkTypeCode.DisorderlyPrice}" tag="a" target="_blank" class="cfff">乱价投诉
          </router-link>
        </div>
      </transition>
      <div class="transList">
        <!-- 个人中心 -->
        <div class="btn center" :class="{'btnBg':btnBgShow[0]}">
          <router-link :to="{name:LinkTypeCode.Mine}" tag="a" target="_blank">
            <van-icon
              :name="`${iconcenter}`"
              size="30"
              @mouseover="showDescription($event,0)"
              @mouseleave="hiddenDescription(0)"
            />
          </router-link>
        </div>
        <!-- 购物车 -->
        <div class="icon-buybar">
          <router-link :to="{name:LinkTypeCode.BuyCar}" tag="a" target="_blank" class="cfff">
            <div style="position: relative; top: 12px;">
              <van-icon :name="`${iconbuy}`" size="30" />
            </div>
            <div class="pr">
              <div class="buy">购物车</div>
            </div>
            <div class="pr h100">
              <div class="pr circle center btm-10">
                <span>{{ carCount>99?'99+':carCount }}</span>
              </div>
            </div>
          </router-link>
        </div>
        <!-- 我的优惠券 -->
        <div class="btn center  mt15i" :class="{'btnBg':btnBgShow[1]}">
          <router-link :to="{name:LinkTypeCode.MyCoupon}" tag="a" target="_blank">
            <van-icon
              :name="`${iconcoupon}`"
              size="30"
              @mouseover="showDescription($event,1)"
              @mouseleave="hiddenDescription(1)"
            />
          </router-link>
        </div>
        <!-- 乱价投诉 -->
        <div class="btn center  mt15i" :class="{'btnBg':btnBgShow[6]}">
          <router-link :to="{name:LinkTypeCode.DisorderlyPrice}" tag="a" target="_blank">
            <van-icon
              :name="`${moreprice}`"
              size="30"
              @mouseover="showDescription($event,6 )"
              @mouseleave="hiddenDescription(6)"
            />
          </router-link>
        </div>
        <!-- 我的收藏 -->
        <div class="btn center " :class="{'btnBg':btnBgShow[2]}">
          <router-link :to="{name:LinkTypeCode.MyCollection}" tag="a" target="_blank">
            <van-icon
              :name="`${iconfavourite}`"
              size="30"
              @mouseover="showDescription($event,2)"
              @mouseleave="hiddenDescription(2)"
            />
          </router-link>
        </div>
        <!-- 我的消息 -->
        <div class="btn center " :class="{'btnBg':btnBgShow[3]}">
          <router-link :to="{name:LinkTypeCode.Msg}" tag="a" target="_blank">
            <van-icon
              :name="`${iconservice}`"
              size="30"
              @mouseover="showDescription($event,3)"
              @mouseleave="hiddenDescription(3)"
            />
          </router-link>
        </div>
        <!-- 在线客服 -->
        <div class="btn center " :class="{'btnBg':btnBgShow[7]}">
          <!-- <router-link :to="{name:LinkTypeCode.Msg}" tag="a" target="_blank"> -->
          <div @click="onlineService">
            <van-icon
              :name="`${icononlineservice}`"
              size="30"
              :badge="undealCount>0?undealCount:''"
              @mouseover="showDescription($event,7)"
              @mouseleave="hiddenDescription(7)"
            />

          </div>
          <!-- </router-link> -->
        </div>
      </div>
      <div class="trandLow">
        <div class="btn center" :class="{'btnBg':btnBgShow[5]}">
          <router-link :to="{name:LinkTypeCode.DownLoad}" tag="a" target="_blank">
            <van-icon
              :name="`${iconphone}`"
              size="30px"
              @mouseover="showDescription($event,5)"
              @mouseleave="hiddenDescription(5)"
            />
          </router-link>
        </div>
        <div class="btn center mt10" :class="{'btnBg':btnBgShow[4]}">
          <van-icon
            :name="`${icontop}`"
            size="30px"
            @mouseover="showDescription($event,4)"
            @mouseleave="hiddenDescription(4)"
            @click="onScrollTop"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { LinkTypeCode } from '../dictionary/base'
import md5 from 'md5'

export default {
  name: 'RightFixedBox',
  data() {
    return {
      LinkTypeCode,
      carCount: 0,
      btnShow: [
        { DesInfoShow: false },
        { DesInfoShow: false },
        { DesInfoShow: false },
        { DesInfoShow: false },
        { DesInfoShow: false },
        { DesInfoShow: false },
        { DesInfoShow: false },
        { DesInfoShow: false }
      ],
      btnOffset: 3,
      btnBgShow: [0, 0, 0, 0, 0, 0, 0],
      btnTopDistance: [0, 0, 0, 0, 0, 0, 0],
      iconbuy: require('../assets/righttoolbar/buy.png'),
      moreprice: require('../assets/righttoolbar/moreprice.png'),
      iconcenter: require('../assets/righttoolbar/center.png'),
      iconcoupon: require('../assets/righttoolbar/coupon.png'),
      iconfavourite: require('../assets/righttoolbar/favourite.png'),
      iconphone: require('../assets/righttoolbar/phone.png'),
      iconservice: require('../assets/righttoolbar/service.png'),
      icononlineservice: require('../assets/righttoolbar/onlineService.png'),
      icontop: require('../assets/righttoolbar/top.png'),
      undealCount: 0 // 在线客服未读消息数
    }
  },
  mounted() {
    this.registerBusEvent()
    this.refCartCount()

    this.getMessageCount()
  },
  methods: {
    registerBusEvent() {
      this.$bus.$on('rightBuycarChanged', (count, isCar) => {
        // console.log(count)
        this.carCount = count
      })
    },
    refCartCount() {
      this.getAction('/api_order/ShoppingCarts/Count').then(res => {
        if (!res.IsSuccess) {
          this.$toast({ position: 'bottom', message: res.Msg })
          return
        }
        this.carCount = res.Data.ProductCount
      })
    },
    showDescription(e, index) {
      this.btnTopDistance[index] = e.currentTarget.getBoundingClientRect().top + 1.5
      this.btnShow[index].DesInfoShow = true
      this.btnBgShow[index] = 1
    },
    hiddenDescription(d) {
      this.btnShow[d].DesInfoShow = false
      this.btnBgShow[d] = 0
    },
    onScrollTop() {
      document.documentElement.scrollTop = 0
    },
    repair(i) {
      if (i >= 0 && i <= 9) {
        return '0' + i
      } else {
        return i
      }
    },
    // 获取在线客服功能客户未读消息数
    getMessageCount() {
      const date = new Date()// 当前时间
      const year = date.getFullYear() // 年
      const month = this.repair(date.getMonth() + 1)// 月
      const day = this.repair(date.getDate())// 日
      const hour = this.repair(date.getHours())// 时
      const minute = this.repair(date.getMinutes())// 分
      const second = this.repair(date.getSeconds())// 秒

      // 当前时间
      const _time = year + month + day + hour + minute + second
      const _sig = md5('T000000190029affad90-018c-11ed-9896-cfccdfdc8f76' + _time).toUpperCase()

      const _data = { _time,
        userId: window.localStorage.getItem('UserId')
      }
      this.postAction(`https://openapis.7moor.com/v20210827/webChat/getUserIdSessionList/T00000019002?sig=${_sig}`, _data).then(res => {
        this.undealCount = res.list?.length > 0 ? res.list[0].undealCount : 0
      })
    },
    // 在线客服
    onlineService() {
      const _params = JSON.stringify(this.auth.getServiceData())
      const _url = `https://ykf-webchat.7moor.com/wapchat.html?accessId=57423a20-fc3f-11ec-94f3-797346435464&fromUrl=http://yyy.hysyzs.com&urlTitle=药约約（客户端）&language=ZHCN&clientId=${window.localStorage.getItem('UserId')}&otherParams={"peerId":"10056316"}&customField=${_params}`
      window.open(_url)
    }
  }
}
</script>
<style lang="less" scoped>
    @c333: #333;
    @bgblue: #0f6ee9;
    @btnHeight: 40px;
    @btnWidth: 40px;

    .rightFixedBox {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      z-index: 1000;
      width: @btnWidth;
      background: #333333;

      .transInfo {
        position: absolute;
        right: @btnWidth;
        z-index: -100;
        width: 90px;
        height: @btnHeight;
        color: white;
        background-color: @bgblue;
        line-height: @btnHeight;
        box-sizing: border-box;
      }

      .transBox {
        height: 100%;
        background-color: @c333;

        .transList {
          width: 100%;

          .btn {
            margin-top: 5px;
            width: 100%;
            height: @btnHeight;
            box-sizing: border-box;
          }

          .icon-buybar {
            position: relative;
            margin-top: 10px;
            width: 100%;
            height: 138px;
            background-color: rgba(15, 110, 233, 1);

            .buy {
              float: left;
              margin: 12px 13px 6px;
              width: 14px;
              height: @btnHeight;
              font-size: 14px;
              font-weight: 600;
              color: rgba(255, 255, 255, 1);
              line-height: 16px;
              box-sizing: border-box;
            }
          }
        }

        .trandLow {
          position: absolute;
          bottom: 100px;
          width: @btnWidth;
          box-sizing: border-box;

          div {
            width: @btnWidth;
            height: @btnHeight;
          }
        }

        /deep/ img {
          cursor: pointer;
        }
      }
    }

    .qrcode {
      padding: 5px !important;
      width: 130px !important;
      height: 130px !important;
      background-color: white !important;
    }

    .circle {
      right: 0;
      left: 0;
      margin: auto;
      border-radius: 50%;
      border-radius: 50%;
      border-radius: 50%;
      width: 26px;
      height: 26px;
      color: rgba(15, 110, 233, 1);
      background-color: rgba(255, 255, 255, 1);
    }

    .btnBg {
      background-color: @bgblue;
    }

    .h100 {
      height: 100px;
    }

    .btm-10 {
      bottom: -10px;
    }

    .pr {
      position: relative;
    }

    .mt15i {
      margin-top: 15px !important;
    }

    .center {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    /* 可以设置不同的进入和离开动画 */

    /* 设置持续时间和动画函数 */
    .slide-fade-enter-active {
      transition: all .2s ease;
    }

    .slide-fade-leave-active {
      transition: all .4s cubic-bezier(1, .5, .8, 1);
    }

    .slide-fade-enter,
    .slide-fade-leave-to

        /* .slide-fade-leave-active 用于 2.1.8 以下版本 */ {
      transform: translateX(100px);
      opacity: 0;
    }
</style>
